import axios from "axios";
import { jsError } from "../../common/utils";

const PDF_API_URL = import.meta.env.VITE_PDF_API_URL ?? "http://localhost:5001";

const pdfReportServiceClient = axios.create({
  baseURL: PDF_API_URL,
  responseType: "blob",
  headers: {
    "Content-Type": "application/json",
  },
});

export const pdfReportServerPost = (url, data) => {
  return pdfReportServiceClient.post(url, data).catch(function (error) {
    if (error.response) {
      // Request made and server responded
      jsError(error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      jsError(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      jsError("pdfReportServerPost Error", error.message);
    }
    return {};
  });
};
